import { useApolloClients } from "~/components/ApolloClients";
import { useGetApprovalConfigQuery } from "~/lib/federationGateway/platformGraphql";
import { useHireJobRequisitionsFlag } from "./useHireJobRequisitionsFlag";

/**
 * Whether the org's Job Requisition workflow is live: the `hire-job-requisitions`
 * LD release flag is on AND the per-org `ApprovalConfig.enabled` toggle is set.
 *
 * When true, ad-hoc job creation is disabled — jobs are created from an approved
 * requisition instead (mirrors the listings `assertAdHocJobCreationAllowed`
 * gate). The config query is skipped entirely while the flag is off.
 */
export const useRequisitionWorkflowEnabled = (): boolean => {
  const flagOn = useHireJobRequisitionsFlag();
  const { platformFederationGatewayClient } = useApolloClients();
  const { data } = useGetApprovalConfigQuery({
    client: platformFederationGatewayClient,
    skip: !flagOn,
    fetchPolicy: "cache-and-network",
  });
  return flagOn && Boolean(data?.approvalConfig.enabled);
};
